import { createResourceSelectors } from "src/redux_resources_v1";

export const revisionsResourceSelectors = createResourceSelectors("revisions");
